import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import CustomizedTimeline from "../components/CustomizedTimeline";
import AccordionComponent from "../components/Accordion";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import "./index.css";

const AUDIENCES = [
  {
    icon: <SchoolOutlinedIcon />,
    title: "Для авторов курсов",
    desc: "Делитесь знаниями в формате, который удерживает внимание. Ученики не просто смотрят видео — они принимают решения и проходят материал в своём темпе.",
    points: [
      "Новый формат вместо скучных записей",
      "Доступ к курсу через ключи — удобно делиться с аудиторией",
      "Можно монетизировать: продавать доступ к программе",
    ],
  },
  {
    icon: <BusinessCenterOutlinedIcon />,
    title: "Для компаний",
    desc: "Быстрее обучайте и интегрируйте сотрудников. Адаптация, продуктовые тренинги и регламенты — в привычном Telegram, без сложных LMS.",
    points: [
      "Новый сотрудник выходит на задачи быстрее",
      "Один сценарий — для всего отдела или офиса",
      "Меньше времени наставников на повторные объяснения",
    ],
  },
];

const BENEFITS = [
  {
    icon: <AccountTreeOutlinedIcon />,
    title: "Сценарии с выбором",
    desc: "Собирайте курс из сцен: разные маршруты для разных ролей, уровней подготовки или исходов ситуаций.",
  },
  {
    icon: <PlayCircleOutlineIcon />,
    title: "Видео-контент",
    desc: "Загружайте уроки прямо в редактор. Каждая сцена — это видео с кнопками выбора следующего шага.",
  },
  {
    icon: <TrendingUpOutlinedIcon />,
    title: "Вовлечённость",
    desc: "Интерактив удерживает внимание: ученик действует, а не пассивно смотрит запись вебинара.",
  },
  {
    icon: <VpnKeyOutlinedIcon />,
    title: "Гибкий доступ",
    desc: "Персональный или групповой, разовый или постоянный — вы сами решаете, кому и на какой срок открыть курс.",
  },
  {
    icon: <GroupsOutlinedIcon />,
    title: "Масштаб команды",
    desc: "Один сценарий — сотни прохождений. Подходит для онбординга, продуктового обучения и корпоративных программ.",
  },
];

const USE_CASES = [
  {
    tag: "Курсы",
    title: "Авторские обучающие программы",
    desc: "Эксперт записывает видео-уроки, добавляет проверочные вопросы и делится доступом с учениками.",
  },
  {
    tag: "HR",
    title: "Адаптация новых сотрудников",
    desc: "Сценарий знакомит с компанией, продуктом и процессами — сотрудник проходит путь шаг за шагом.",
  },
  {
    tag: "Продажи",
    title: "Обучение продукту и скриптам",
    desc: "Интерактивные кейсы: как отвечать на возражения, какие шаги делать в типовых ситуациях.",
  },
  {
    tag: "Compliance",
    title: "Регламенты и инструкции",
    desc: "Сотрудник принимает решения в симуляции и видит последствия — материал запоминается лучше.",
  },
];

export default function MainPage() {
  return (
    <div className="landing landing--pattern">
      <section className="landing-hero landing-hero--mesh">
        <div className="landing-hero__content">
          <span className="landing-hero__badge">
            Конструктор интерактивных курсов
          </span>
          <h1 className="landing-hero__title">MOGAME</h1>
          <p className="landing-hero__subtitle">
            Запишите уроки, соберите интерактивный сценарий — и ваша аудитория
            или команда начнёт проходить его в Telegram. Без установки
            приложений и долгой настройки.
          </p>
          <div className="landing-hero__actions">
            <Link to="/login?tab=register">
              <Button
                variant="contained"
                size="large"
                className="landing-hero__btn-primary"
              >
                Создать первый курс
              </Button>
            </Link>
            <Link to="/login">
              <Button
                variant="outlined"
                size="large"
                className="landing-hero__btn-secondary"
              >
                Войти
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <section className="landing-section landing-section--audience">
        <div className="landing-container">
          <div className="landing-section__header">
            <h2 className="landing-section__title">Кому подходит MOGAME</h2>
            <p className="landing-section__desc">
              Для экспертов, которые делятся знаниями, и для компаний, которым
              важно быстрее обучать и интегрировать сотрудников
            </p>
          </div>
          <div className="landing-audience">
            {AUDIENCES.map(({ icon, title, desc, points }) => (
              <article className="landing-audience-card" key={title}>
                <div className="landing-audience-card__icon">{icon}</div>
                <h3 className="landing-audience-card__title">{title}</h3>
                <p className="landing-audience-card__desc">{desc}</p>
                <ul className="landing-audience-card__list">
                  {points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="landing-section landing-section--benefits">
        <div className="landing-container">
          <div className="landing-section__header">
            <h2 className="landing-section__title">
              Почему интерактив работает лучше обычного видео
            </h2>
            <p className="landing-section__desc">
              Линейный курс теряет внимание на третьей минуте. Сценарий с
              выбором превращает обучение в практику
            </p>
          </div>
          <div className="landing-benefits landing-benefits--five">
            {BENEFITS.map(({ icon, title, desc }) => (
              <article className="landing-benefit-card" key={title}>
                <div className="landing-benefit-card__icon">{icon}</div>
                <h3 className="landing-benefit-card__title">{title}</h3>
                <p className="landing-benefit-card__desc">{desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="landing-section landing-section--value">
        <div className="landing-container">
          <div className="landing-section__header">
            <h2 className="landing-section__title">Какой результат вы получите</h2>
            <p className="landing-section__desc">
              Один инструмент — разная выгода для авторов курсов и для компаний
            </p>
          </div>
          <div className="landing-value">
            <article className="landing-value-card">
              <div className="landing-value-card__icon">
                <AttachMoneyOutlinedIcon />
              </div>
              <h3 className="landing-value-card__title">Для авторов курсов</h3>
              <p className="landing-value-card__desc">
                Вы создаёте программу один раз и продаёте доступ ученикам через
                ключи. Каждый покупатель получает свой ключ — вы контролируете,
                кто и когда начинает прохождение.
              </p>
              <ul className="landing-value-card__list">
                <li>Прямая монетизация экспертизы</li>
                <li>Масштаб без дополнительных записей</li>
                <li>Формат, который выделяет курс среди конкурентов</li>
              </ul>
            </article>
            <article className="landing-value-card">
              <div className="landing-value-card__icon landing-value-card__icon--corp">
                <SavingsOutlinedIcon />
              </div>
              <h3 className="landing-value-card__title">Для компаний</h3>
              <p className="landing-value-card__desc">
                Вы не продаёте курс — вы экономите время и деньги на обучении.
                Готовый сценарий заменяет повторные объяснения наставника: новый
                сотрудник проходит программу сам, в удобное время, в Telegram.
              </p>
              <ul className="landing-value-card__list">
                <li>Быстрее выход новичка на рабочие задачи</li>
                <li>Меньше нагрузки на HR и руководителей</li>
                <li>Единый стандарт обучения для всей команды</li>
              </ul>
            </article>
          </div>
        </div>
      </section>

      <section className="landing-section landing-section--intro">
        <div className="landing-container">
          <div className="landing-intro">
            <div className="landing-video">
              <video controls>
                <source src="/video/main.mp4" type="video/webm" />
              </video>
            </div>
            <div>
              <h2 className="landing-intro__heading">
                Как это работает: от идеи курса до прохождения учеником
              </h2>
              <p className="landing-intro__text">
                Вы создаёте сценарий в веб-редакторе, загружаете видео-уроки и
                настраиваете переходы между сценами. Ученик или сотрудник
                получает ключ доступа и проходит программу в Telegram — смотрит
                ролик и выбирает следующий шаг.
              </p>
              <div className="landing-intro__highlights">
                <div className="landing-intro__highlight">
                  <strong>Новый формат</strong> — не очередной PDF и не
                  скучная запись
                </div>
                <div className="landing-intro__highlight">
                  <strong>Telegram</strong> — прохождение там, где люди уже
                  каждый день
                </div>
                <div className="landing-intro__highlight">
                  <strong>Без лишней возни</strong> — редактор, видео, ключи
                  доступа, запуск
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="landing-section landing-section--steps">
        <div className="landing-container">
          <div className="landing-section__header">
            <h2 className="landing-section__title">
              Четыре шага до запуска программы
            </h2>
            <p className="landing-section__desc">
              От структуры курса до выдачи доступа — без программистов и
              сложных интеграций
            </p>
          </div>
          <CustomizedTimeline />
        </div>
      </section>

      <section className="landing-section landing-section--showcase">
        <div className="landing-container">
          <div className="landing-showcase">
            <div className="landing-showcase__media">
              <img
                src="/images/workspace.png"
                alt="Редактор сценария обучения"
              />
              <div className="landing-showcase__caption">
                Редактор сценария — визуальная карта курса
              </div>
            </div>
            <div className="landing-showcase__text">
              <h2 className="landing-showcase__title">Создавать это просто</h2>
              <p className="landing-showcase__desc">
                Визуальный редактор: собирайте программу обучения как карту
                сцен. Каждый блок — урок с видео и вариантами перехода дальше.
              </p>
              <ul className="landing-showcase__list">
                <li>Создавайте сцены уроков</li>
                <li>Загружайте обучающее видео</li>
                <li>Добавляйте кнопки выбора и маршруты сценария</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="landing-section landing-section--showcase-alt">
        <div className="landing-container">
          <div className="landing-showcase landing-showcase--reverse">
            <div className="landing-showcase__media">
              <img
                src="/images/project_settings.png"
                alt="Настройки курса"
              />
              <div className="landing-showcase__caption">
                Настройки курса и управление доступом
              </div>
            </div>
            <div className="landing-showcase__text">
              <h2 className="landing-showcase__title">Простые настройки</h2>
              <p className="landing-showcase__desc">
                Минимум полей — только то, что нужно для запуска. Название,
                описание, обложка и ключи доступа для учеников или отдела.
              </p>
              <ul className="landing-showcase__list">
                <li>Название и описание программы</li>
                <li>Обложка курса для учеников</li>
                <li>Ключи: персональные, групповые, разовые или постоянные</li>
                <li>Быстрый старт без технической подготовки</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="landing-section landing-section--usecases">
        <div className="landing-container">
          <div className="landing-section__header">
            <h2 className="landing-section__title">Сценарии использования</h2>
            <p className="landing-section__desc">
              MOGAME подходит и для авторских программ, и для внутреннего
              обучения в компании
            </p>
          </div>
          <div className="landing-usecases">
            {USE_CASES.map(({ tag, title, desc }) => (
              <article className="landing-usecase-card" key={title}>
                <span className="landing-usecase-card__tag">{tag}</span>
                <h3 className="landing-usecase-card__title">{title}</h3>
                <p className="landing-usecase-card__desc">{desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="landing-cta">
        <h2 className="landing-cta__title">
          Запустите первый интерактивный курс
        </h2>
        <p className="landing-cta__desc">
          Создайте сценарий, загрузите уроки и выдайте доступ — ученики начнут
          проходить программу уже сегодня.
        </p>
        <div className="landing-cta__actions">
          <Link to="/login?tab=register">
            <Button
              variant="contained"
              size="large"
              className="landing-hero__btn-primary"
            >
              Создать курс
            </Button>
          </Link>
          <Link to="/login">
            <Button
              variant="outlined"
              size="large"
              className="landing-hero__btn-secondary"
            >
              Уже есть аккаунт — войти
            </Button>
          </Link>
        </div>
      </section>

      <section className="landing-faq landing-section--faq">
        <div className="landing-container">
          <div className="landing-section__header">
            <h2 className="landing-section__title">Частые вопросы</h2>
            <p className="landing-section__desc">
              О платформе, доступе и запуске обучающих программ
            </p>
          </div>
          <AccordionComponent />
        </div>
      </section>

      <div className="footer">
        <div>
          <a
            href="/oferta"
            target="_blank"
            rel="noreferrer"
            style={{ color: "white" }}
          >
            Оферта
          </a>
        </div>
      </div>
    </div>
  );
}
